import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .RecordsBonusesTable {
    .ReactDataTable__wrapper {
      @include respond-to(xl) {
        overflow-x: auto;
      }

      .ReactDataTable th,
      .ReactDataTable td {
        padding: 3px;
      }

      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(90px, 1.5fr) /* email */
            minmax(90px, 1fr) /* bonusType */
            minmax(90px, 1fr) /* account */
            minmax(130px, 1.5fr) /* receivingDate */
            minmax(130px, 1.5fr) /* validUntil */
            minmax(80px, 1fr) /* value */
            minmax(50px, 1fr) /* fulfillmentOfTerms */
            minmax(50px, 1fr) /* termsOfReceipt */
            minmax(70px, 1.2fr) /* status */
            minmax(120px, 1.5fr) /* withdrawDate */
            minmax(110px, 1fr); /* actions */
        }

        .ReactDataTable__tbody-row {
          height: 70px;
          font-size: 13px;
          padding: 0 5px;
          align-items: center;
        }

        /* Email (col 1) */
        .ReactDataTable__tbody-cell:first-child .RowLink__bonuses {
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* BonusType (col 2) */
        .ReactDataTable__tbody-cell:nth-child(2) .RecordsBonusesTable__types {
          display: flex;
          flex-direction: column;
        }

        /* Value (col 6) */
        .ReactDataTable__tbody-cell:nth-child(6) .MoneyCell__inner span {
          font-size: 13px !important;
        }

        /* Status (col 9) */
        .ReactDataTable__tbody-cell:nth-child(9) .StatusCell {
          font-size: 11px !important;
        }

        /* Actions button */
        .ReactDataTable__tbody-cell:nth-child(11) button {
          span {
            font-size: 13px !important;
            line-height: normal;
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;

      span {
        text-align: center;
        padding: 5px 0;

        &:first-child {
          flex: 10; /* email */
        }

        &:nth-child(2) {
          flex: 8; /* bonusType */
        }

        &:nth-child(3) {
          flex: 6; /* value */
        }

        &:nth-child(4) {
          flex: 6; /* status */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:first-child {
          flex: 10; /* email */
          font-weight: 500;
          font-size: rem(14px);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          justify-content: flex-start;
        }

        &:nth-child(2) {
          flex: 8; /* bonusType */
          .RecordsBonusesTable__types {
            display: flex;
            flex-direction: column;
          }
        }

        &:nth-child(3) {
          flex: 6; /* value */
          font-size: rem(13px);
        }

        &:nth-child(4) {
          flex: 6; /* status */
          font-size: rem(13px);
        }
      }
    }

    .RecordsBonusesTable__cancel-error {
      max-width: 360px;
      margin-top: rem(10px);
    }
  }

  .BonusModal {
    :global(&__btns) {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .RecordsBonusesTable {
      &__until {
        &.active,
        &.completed {
          color: ${colors.success.hex};
        }

        &.expired {
          color: ${colors.error.hex};
        }

        &.rejected {
          color: ${colors.gray.hex};
        }
      }

      .defaultType {
        color: ${colors.gray.hex};
      }
    }

    .RecordsBonusesTable__cancel-error {
      color: ${colors.error.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
